import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  const navigate = useNavigate();
  return (
    <div className="relative min-h-screen bg-ink text-white grid lg:grid-cols-2 overflow-hidden">
      <div className="noise-overlay" />
      {/* left brand panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 border-r border-white/10 overflow-hidden">
        <div className="glow-orb w-[500px] h-[500px] -left-32 top-10 bg-dox-purple/25" />
        <div className="glow-orb w-[420px] h-[420px] right-0 bottom-0 bg-dox-orange/20" />
        <div className="absolute inset-0 grid-lines opacity-50" />
        <div className="relative z-10">
          <Logo maxWidth={520} />
        </div>
        <div className="relative z-10">
          <h2 className="font-display font-black text-5xl leading-[0.95] tracking-tight">
            Stop doing<br />paperwork.<br /><span className="text-gradient-brand">Let DOX do it.</span>
          </h2>
          <p className="mt-6 text-white/55 max-w-sm">
            Your AI Compliance Employee is ready to review, organize and keep your business compliant — automatically.
          </p>
        </div>
        <div className="relative z-10 text-xs text-white/40 tracking-[0.2em] uppercase">
          Let Dox do it.
        </div>
      </div>

      {/* right form panel */}
      <div className="relative z-10 flex flex-col justify-center px-6 sm:px-16 py-16">
        <button
          data-testid="auth-back-home"
          onClick={() => navigate("/")}
          className="absolute top-8 left-6 sm:left-10 flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors"
        >
          <ArrowLeft size={16} /> Back home
        </button>
        <div className="lg:hidden mb-8"><Logo maxWidth={280} /></div>
        <div className="max-w-md w-full">
          <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tight">{title}</h1>
          <p className="mt-2 text-white/55">{subtitle}</p>
          <div className="mt-8">{children}</div>
          <div className="mt-6 text-sm text-white/50">{footer}</div>
        </div>
      </div>
    </div>
  );
}
